import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Button, Checkbox, Container, FormField, Link, Modal, SpaceBetween, StatusIndicator, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiCheckCircle, mdiDraw, mdiDrawPen, mdiSignature, mdiSignatureFreehand } from '@mdi/js';
import Icon from '@mdi/react';
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemACK } from '../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../commons/functions';

export const UserACKPage = () => {
    const { idUser, data, menu, parameters, version, loading, notifications, displayName, RUT } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();

    const [ACKs, setACKs] = useState<ItemACK[]>([]);
    const [ACK, setACK] = useState<ItemACK>();
    const [ACKSign, setACKSign] = useState<ItemACK>();


    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id === null) {
                setACK(undefined);
                handleGetACKs()
            }
            else {
                handleGetACK(parseInt(id));
                if (!ACKs || ACKs.length === 0) {
                    console.log(ACKs.length)
                    handleGetACKs()
                }
            }
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    const handleReadACK = async (idACK: number) => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/acks/read',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ idACK: idACK })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data) {
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleSignACK = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/acks/sign',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ idACK: ACK.idACK })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data) {
                if (data.code === 0) {
                    window.location.hash = "#user/acks";
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleGetACK = async (idACK: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/acks/ack',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ idACK: idACK })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data) {
                addNotificationStatus(data, setData);
                if (data.code === 0 && data.ACK) {

                    setIsAtBottom(true);
                    setRead(false);
                    setACK(data.ACK)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleGetACKs = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/acks/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    columns: "idACK, fechaACK, isActiveACK, isReadACK2, isSignACK2, ACKTitle",
                    orderBy: "fechaACK", order: "desc",
                    isActiveACK: 1,
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data) {
                if (data.code === 0 && data.ACKs) {
                    setACKs(data.ACKs)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        //handleGetACKs();
    }, [])
    const unsignedACKs = ACKs.filter((ack) => !ack.isSignACK.includes(idUser)).length || 0;
    //console.log(ACKs.filter((ack) => !ack.isSignACK.includes(idUser)))

    const divRef = useRef<HTMLDivElement>(null);
    const [isAtBottom, setIsAtBottom] = useState(true);
    const [read, setRead] = useState(false);
    const [onlyPendings, setOnlyPendings] = useState(true);

    const checkIfScrolledToBottom = (element: HTMLDivElement | null): boolean => {
        if (!element) return true;
        const { scrollHeight, clientHeight, scrollTop } = element;
        if (scrollHeight <= clientHeight) {
            return true;
        }
        return Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    };

    const filtered = ACKs.filter((ack: ItemACK) => onlyPendings ? ack.isSigned === 0 : true);

    useEffect(() => {
        if (!ACK) return;

        const timer = setTimeout(() => {
            if (!divRef.current) return;

            const container = divRef.current;
            const images = Array.from(container.querySelectorAll('img'));

            // Find any images that are not yet fully loaded
            const pendingImages = images.filter(img => !img.complete);

            const evaluateScrollState = () => {
                const hasReached = checkIfScrolledToBottom(container);
                setIsAtBottom(hasReached);
                if (hasReached) {
                    console.log("User has scrolled to the bottom of the ACK content.");
                    setRead(true);
                }
            };
            console.log("pendingImages", pendingImages)

            if (pendingImages.length > 0) {
                // Wait for all pending images to load before final calculation
                let loadedCount = 0;
                const handleImageLoad = () => {
                    loadedCount++;
                    if (loadedCount === pendingImages.length) {
                        evaluateScrollState();
                    }
                };

                pendingImages.forEach(img => {
                    img.addEventListener('load', handleImageLoad, { once: true });
                    img.addEventListener('error', handleImageLoad, { once: true }); // handle broken images too
                });
            } else {
                // No pending images, evaluate immediately
                evaluateScrollState();
            }
        }, 500); // Initial delay for modal open

        return () => clearTimeout(timer);
    }, [ACK]);

    const handleScroll = () => {
        if (divRef.current) {
            const hasReached = checkIfScrolledToBottom(divRef.current);
            setIsAtBottom(hasReached);
            if (!read && hasReached) {
                setRead(true);
            }
        }
    };
    useEffect(() => {
        if (read && ACK) {
            console.log("User has scrolled to the bottom of the ACK content. Marking as read.");
            handleReadACK(ACK.idACK);
        }
    }, [read, ACK]);


    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Tomas de razón</Header>
                    {unsignedACKs > 0 && (
                        <Alert type="warning" header="Pendientes" dismissible={false}>
                            Tiene {unsignedACKs} toma{unsignedACKs === 1 ? "" : "s"} de razón pendiente{unsignedACKs === 1 ? "" : "s"} de firma.
                        </Alert>
                    )}

                    {!!ACKs && (
                        <SpaceBetween direction="vertical" size="xs">
                            <Checkbox checked={onlyPendings} onChange={() => setOnlyPendings(!onlyPendings)}>Mostrar solo pendientes de firma obligatoria</Checkbox>
                            <Table
                                header={<Header variant="h2" />}
                                stickyHeader
                                variant='embedded'
                                columnDefinitions={[
                                    {
                                        id: 'ACK',
                                        header: 'Fecha',
                                        cell: (item) => <FormField
                                            constraintText={item.fechaACK}
                                            label={<Link href={`#user/acks?id=${item.idACK}`}>{item.ACKTitle}</Link>} />,
                                    },
                                    {
                                        id: 'Firmada',
                                        header: 'Firmada',
                                        cell: (item) =>
                                            item.isSignACK.includes(idUser) ? (
                                                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                    Firmada <Icon path={mdiSignatureFreehand} size={1} />
                                                </span>
                                            ) : (
                                                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                    Pendiente de firma <Icon path={mdiSignature} color="red" size={1} />
                                                </span>
                                            ),
                                        width: 100,
                                    },

                                ]}
                                empty={

                                    unsignedACKs === 0 && onlyPendings && (
                                        <Alert type="success" header="Pendientes" dismissible={false}>
                                            No tiene tomas de razón pendientes de firma.
                                        </Alert>
                                    )
                                }
                                items={filtered}
                                loadingText="Loading ACKs..."
                            />
                        </SpaceBetween>
                    )}
                    {!!ACK && (
                        <Modal visible={!!ACK} header={`Toma de razón #${ACK.idACK}`} size='large' onDismiss={() => window.location.hash = "#user/acks"}
                            footer={
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                    }}>
                                    <Button variant="link" onClick={() => window.location.hash = "#user/acks"}>Cerrar</Button>
                                    {ACK.isSignACK.includes(idUser) ?
                                        <div>
                                            <Header variant="h2"><Icon path={mdiDrawPen} size={1} /> Firmada <Icon path={mdiCheckCircle} color="green" size={1} /></Header></div>
                                        :
                                        !read && !ACK.isSignACK.includes(idUser) ? <StatusIndicator type="warning">Debe llegar al final de la toma de razón para habilitar la firma</StatusIndicator> :

                                            <Button variant="primary" onClick={() => handleSignACK()} disabled={!read}><Icon path={mdiDraw} size={1} /> Firmar</Button>
                                    }

                                </div>

                            }
                        >
                            <SpaceBetween size="m" direction="vertical">
                                <Container>
                                    <SpaceBetween size="m" direction="vertical">
                                        <div ref={divRef} onScroll={handleScroll} style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: "100%",
                                            maxHeight: "300px", // Set a fixed or max height so overflow can happen
                                            overflowY: "auto",   // Enables scrollbar when content exceeds maxHeight
                                        }}>
                                            <div dangerouslySetInnerHTML={{ __html: ACK.ACK || "" }} />
                                        </div>


                                    </SpaceBetween>
                                </Container>
                            </SpaceBetween>

                        </Modal>
                    )}
                </SpaceBetween>
            }
        />
    )
};
